<div class="card">
  <div class="card-body">
    <h4 class="card-title">Informazioni generali</h4>
      <div class="row"  *ngIf="permission.HasnotCapacity(['is-cliente-ordine'])">
        <div class="col-sm-12 col-lg-3" >
          <label for="cliente" class="control-label col-form-label" >Azienda:</label>
          <ng-multiselect-dropdown id="cliente" [disabled]="isModifyDisabled || !permission.isPermitted('menu-clienti')" required #cliente="ngModel" [settings]="clientidropdownSettings" [placeholder]="'Seleziona'" name="cliente"
                                   [data]="clienti" [(ngModel)]="clienteSelezionato" (onFilterChange)="filtroCliente($event)" (ngModelChange)="clientecambiato($event)" (onMoreButtonClick)="CercaAdhoc($event)" >
          </ng-multiselect-dropdown>
          <i class="fas fa-exclamation-triangle text-warning" [ngbTooltip]="'Necessario OK amministrativo'" *ngIf="ProgettoSelezionato?.clienteObject?.checkAmm"></i>
        </div>
        <div class="col-sm-12 col-lg-3" *ngIf="!cliente.valid && permission.HasnotCapacity(['is-cliente-ordine']) && permission.isPermitted('gestione-clienti') && !isModifyDisabled && !environment.ProgettiAddon['CampiNuovoCliente']">
          <label for="cliente" class="control-label col-form-label">Ragione Sociale:</label>
          <input #rsoc="ngModel" required [ngClass]="{ 'is-invalid': !rsoc.valid && !isModifyDisabled && (rsoc.dirty || rsoc.touched) }" [(ngModel)]="nuovoCliente.nominativo" type="text" class="form-control" id="rsoc" placeholder="Ragione Sociale">
          <small class="form-text text-danger" *ngIf="(!cliente.valid && !isModifyDisabled && !rsoc.valid )">Cliente richiesto!</small>
        </div>

        <ng-container *ngIf="!cliente.valid && permission.HasnotCapacity(['is-cliente-ordine']) &&  permission.isPermitted('gestione-clienti') && !isModifyDisabled && environment.ProgettiAddon['CampiNuovoCliente']">
          <app-field-viewer class="col-12" [(Campi)]="environment.ProgettiAddon['CampiNuovoCliente']" [(Oggetto)]="nuovoCliente"></app-field-viewer>
        </ng-container>
      </div>
    <div class="row">
      <app-field-viewer class="col-12" [(DropdownSources)]="DropdownSources" [(Campi)]="environment?.ProgettiAddon.CampiOfferta" (OnChange)="ChangeHandler(ProgettoSelezionato, $event)" (OnFilter)="FilterHandler($event.OnFilter, $event.Event)" [(Oggetto)]="ProgettoSelezionato"></app-field-viewer>

      <div class="col-lg-1" *ngIf="environment.ProgettiAddon['Revisioni'] && ProgettoSelezionato?.rev > 0">
        <div class="form-group">
          <label for="Revisione" class="control-label col-form-label">Revisione:</label>
          <input [(ngModel)]="ProgettoSelezionato.rev" readonly type="text" class="form-control" id="Revisione" placeholder="Revisione">
        </div>
      </div>
      <div class="col-lg-3" *ngIf="permission.HasnotCapacity(['is-cliente-ordine'])">
        <button type="submit" (click)="setDate()" class="ml-auto btn-dark p-2 waves-effect waves-light">
          <span class="ml-1 text-white font-weight-bold">Imposta tutte le date</span>
        </button>
      </div>
    </div>
  </div>
</div>


<div  *ngIf="ProgettoSelezionato?.progetti?.length > 0  && !isPreventivo" >
  <div class="card" *ngFor="let item of ProgettoSelezionato.progetti; let i = index">
    <div class="card-body">
      <div class="">
        <h5 class="card-title">{{ item['codiceCommessa'] ?? item.oggetto ?? "" }}</h5>
        <a class="" *ngIf="environment.ProgettiAddon['deleteSubProject'] && item?.id" (click)="deleteSubproject(item)"><i class=" fas fa-trash"></i></a>
      </div>
      
      <app-field-viewer  [(DropdownSources)]="DropdownSources" [(Campi)]="environment?.ProgettiAddon.CampiSottoOfferta" (OnChange)="ChangeHandler(item, $event)" [(Oggetto)]="ProgettoSelezionato.progetti[i]"></app-field-viewer>
      <div class="row">
        <div class="col-sm-12 col-lg-3" *ngIf="environment.ProgettiAddon['tipoPagamento']">
          <label  class="control-label col-form-label">Pagamento :</label>
          <ng-multiselect-dropdown [placeholder]="'Seleziona'"
                                   [settings]="idnomedropdownSettings"
                                   [data]="tipiPagamento"
                                   [disabled]="permission.isOperativeRoles(['AG', 'K'])"
                                   [(ngModel)]="item.pagamentoObject"
                                   (ngModelChange)="pagamentoChange(item)"
          >
          </ng-multiselect-dropdown>
        </div>
        <div class="col-sm-12 col-lg-3" *ngIf="environment.ProgettiAddon['banche'] && !permission.isOperativeRoles(['AG', 'K'])">
          <label  class="control-label col-form-label">Banca :</label>
          <ng-multiselect-dropdown [placeholder]="'Seleziona'"
                                   [settings]="idnomedropdownSettings"
                                   [data]="banche"
                                   [disabled]="permission.isOperativeRoles(['AG', 'K'])"
                                   [(ngModel)]="ProgettoSelezionato.bancaObject"
                                   (ngModelChange)="bancaChange(ProgettoSelezionato)"
          >
          </ng-multiselect-dropdown>
        </div>
        <div class="col-sm-12 col-lg-1" style="max-width: 140px" *ngIf="environment.ProgettiAddon['pagato']">
          <label  class="control-label col-form-label">&nbsp;</label>
          <div class="input-group "  >
            <div class="input-group-prepend">
              <label class="input-group-text" for="cliente">Pagato </label>
            </div>
            <input [(ngModel)]="item.pagato" style="min-width: 50px" type="checkbox" class="form-control">
          </div>
<!--          <label  class="control-label col-form-label">Pagato :</label>-->
<!--          <input [(ngModel)]="item.pagato" type="checkbox" class="form-control">-->
        </div>
        <div class="col-sm-12 col-lg-3" style="max-width: 300px" *ngIf="environment.ProgettiAddon['francoDeposito']">
          <label  class="control-label col-form-label">&nbsp;</label>
          <div class="input-group "  >
            <div class="input-group-prepend">
              <label class="input-group-text" for="cliente">FRANCO DEPOSITI KLIMAITALIA</label>
            </div>
            <input [(ngModel)]="item.francoDeposito" style="min-width: 50px" type="checkbox" class="form-control">
          </div>
<!--          <label  class="control-label col-form-label">FRANCO DEPOSITI KLIMAITALIA :</label>-->
<!--          <input [(ngModel)]="item.francoDeposito" type="checkbox" class="form-control">-->
        </div>
      </div>
      <br>
      <div class="col-12">
      </div>
        <ul  ngbNav #subnav="ngbNav"  class="nav-tabs">
          <li ngbNavItem="voci" *ngIf="!environment.ProgettiAddon['HideVoci']">
            <a ngbNavLink> Voci di costo </a>
            <ng-template ngbNavContent>
              <app-voci-di-costo
                [isModifyDisabled]="isModifyDisabled"
                [HasSubOffer]="true"
                [myProp]="item"
                [HasUm]="environment.ProgettiAddon['HidePrezzo'] != true"
                [HasPrezzo]="environment.ProgettiAddon['HidePrezzo'] != true"
                [HasTotale]="environment.ProgettiAddon['HidePrezzo'] != true"
                [HasIva]="environment.ProgettiAddon['HidePrezzo'] != true"
                [HasIvato]="environment.ProgettiAddon['HideIvato'] != true"
                (resetpage)="refresh()"
                (Salva)="saveClick()"
                [(Cliente)]="clienteSelezionato"
                [CampiAggiuntivi]="environment.ProgettiAddon['CampiAggiuntivi']"
                [VociCostoButtons]="environment.ProgettiAddon['VociCostoButtons']"
              ></app-voci-di-costo>
            </ng-template>
          </li>
          <li ngbNavItem="ProvaAcquisto" *ngIf="environment.ProgettiAddon['ProvaAcquisto'] && ProgettoSelezionato?.id">
            <a ngbNavLink> Impianti </a>
            <ng-template ngbNavContent>
              <app-lista-prova-acquisto [Progetto]="item" [Cliente]=""></app-lista-prova-acquisto>
            </ng-template>
          </li>
          <li ngbNavItem="Task" *ngIf="permission.isPermitted('menu-fasi') && environment.Modules.Interventi && item?.id">
            <a ngbNavLink> Attività </a>
            <ng-template ngbNavContent>
              <div class=" m-b-5 m-t-5 m-l-5 m-r-5">
                <app-lista-interventi-offerta [(Offerta)]="ProgettoSelezionato.progetti[i]" [hasAddButton]="true" ></app-lista-interventi-offerta>
              </div>
            </ng-template>
          </li>
          <li ngbNavItem="Blocchi" *ngIf="permission.isPermitted('menu-blocchi') &&!environment.ProgettiAddon['HideBlocchi'] && !environment.ProgettiAddon['CampiVociPreventivo'] && item?.id">
            <a ngbNavLink> Blocchi </a>
            <ng-template ngbNavContent>
              <div class=" m-b-5 m-t-5 m-l-5 m-r-5">
                <app-blocchi-list [(Blocchi)]="item.blocchi"></app-blocchi-list>
              </div>
            </ng-template>
          </li>
          <li ngbNavItem="Destinazioni" *ngIf="environment.ProgettiAddon['destinazioni']">
            <a ngbNavLink> Destinazioni </a>
            <ng-template ngbNavContent>
              <app-destinazioni-list *ngIf="item" [(projectId)]="item.id" [title]="'Destinazioni'" [(clientObject)]="ProgettoSelezionato.clienteObject"></app-destinazioni-list>
            </ng-template>
          </li>
          <li ngbNavItem="Rma" *ngIf="environment.ProgettiAddon['rma']">
            <a ngbNavLink> Attività </a>
            <ng-template ngbNavContent>
              <app-rma-list [filtri]="{page: 0, size: 10, progetto: item.id, list:'rma'}" ></app-rma-list>
<!--              <app-destinazioni-list *ngIf="item" [(projectId)]="item.id" [title]="'Attivita'" [(clientObject)]="ProgettoSelezionato.clienteObject"></app-destinazioni-list>-->
            </ng-template>
          </li>
<!--          <li ngbNavItem="files" *ngIf="!environment.ProgettiAddon['hideFile'] && permission.isPermitted('lista-file') ">-->
<!--            <a ngbNavLink> Files </a>-->
<!--            <ng-template ngbNavContent>-->
<!--              <app-file-uploader [url]="'/progetti/progetti/file'" [(id)]="ProgettoSelezionato.id" [(listafile)]="ProgettoSelezionato.files" (onChange)="onFileChanged()"></app-file-uploader>-->
<!--            </ng-template>-->
<!--          </li>-->
        </ul>
        <div [ngbNavOutlet]="subnav" class="mt-2"></div>
    </div>
  </div>
</div>
<div  *ngIf="ProgettoSelezionato?.progetti?.length > 0 && isPreventivo" >
  <div class="card" *ngFor="let item of ProgettoSelezionato.progetti; let i = index">
    <div class="d-flex align-items-center justify-content-between bg-white card-body" *ngIf="!item.hide" >
      <a href="javascript:void(0)" (click)="item.hide = !item.hide"><i class="fas fa-chevron-down text-dark" style="transition: all 0.3s ease-out; transform-origin: top;" [style.transform]="!item.hide? 'rotate(180deg) translate(0, -50%)' : ''"></i></a>
    </div>
    <app-sector-viewer *ngIf="!item.hide"  [(DropdownSources)]="DropdownSources" [(Campi)]="environment?.ProgettiAddon['CampiSottoOffertaPreventivo']" (OnChange)="ChangeHandler(item, $event)" [(Oggetto)]="ProgettoSelezionato.progetti[i]"></app-sector-viewer>

  </div>
  <div class="table-responsive" *ngIf="(ProgettoSelezionato.progetti | SottoprogettiNascosti: true).length > 0">
    <table class="table bg-white table-hover align-middle " style="margin-bottom: 70px;">
      <thead>
      <tr>
        <th scope="col" [style]="campo.titleStyle" [class]="campo.titleClass" *ngFor="let campo of environment.ProgettiAddon['CampiVociPreventivo']">{{ campo.nome | translate }}</th>
        <th scope="col" >Azioni</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of ProgettoSelezionato.progetti | SottoprogettiNascosti: true">
        <td class="align-middle" *ngFor="let campo of environment.ProgettiAddon['CampiVociPreventivo']" >
          <ng-container *ngFor="let oggetto of campo.oggetti; let i = index">
            <ng-template [ngIf]="campo.inputType != 'checkbox' && campo.inputType != 'singleDropdown' && campo.inputType != 'multiselectDropdown' && campo.type != 'ArrayCampiAggiuntivi' && campo.type != 'checkboxArray'">
              <span *ngIf="campo.inputType != 'date' && campo.inputType != 'datetime-local' && campo.inputType != 'euro'" [class]="campo.inputClass" [ngStyle]="campo.inputStyle">{{campo.prefix ?? ''}}{{getObject(campo,i,item) }}{{campo.suffix ?? ''}}</span>
              <span *ngIf="campo.inputType == 'date'" [class]="campo.inputClass" [ngStyle]="campo.inputStyle">{{campo.prefix ?? ''}}{{getObject(campo,i,item) | date: 'dd/MM/yyyy'}}{{campo.suffix ?? ''}}</span>
              <span *ngIf="campo.inputType == 'datetime-local'" [class]="campo.inputClass" [ngStyle]="campo.inputStyle">{{campo.prefix ?? ''}}{{getObject(campo,i,item) | date: 'dd/MM/yyyy HH:mm'}}{{campo.suffix ?? ''}}</span>
              <span *ngIf="campo.inputType == 'euro'" [class]="campo.inputClass" [ngStyle]="campo.inputStyle">{{campo.prefix ?? ''}}{{getObject(campo,i,item) | number: '2.2-2'}}&nbsp;€{{campo.suffix ?? ''}}</span>
            </ng-template>
            <ng-template [ngIf]="campo.inputType == 'checkbox'">
              <span [class.text-danger]="!getObject(campo,i,item)" [class.text-success] = "getObject(campo,i, item)" >
                {{campo.prefix ?? ''}}
                <i [class.far] ="!getObject(campo,i,item)" [class.fa-times-circle] ="!getObject(campo,i,item)" [class.fas] ="getObject(campo,i,item)" [class.fa-check-circle] ="getObject(campo,i,item)" ></i>
                {{campo.suffix ?? ''}}
              </span>
            </ng-template>
          </ng-container>
        </td>
        <td class="align-middle" >
          <a href="javascript:void(0)" ngbTooltip="Espandi"
             class="link font-16 font-weight-bold" (click)="item.hide = !item.hide">
            <i class="fas fa-chevron-down text-dark" style="transition: all 0.3s ease-out; transform-origin: top;"  [style.transform]="!item.hide? 'rotate(180deg) translate(0, -50%)' : ''"></i>
          </a>
          &nbsp;
          <a href="javascript:void(0)" ngbTooltip="Rimuovi"
             class="link font-16 font-weight-bold" (click)="deleteSubOfferta($event, item)">
            <i class="fas fa-trash-alt text-danger" ></i>
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="d-flex justify-content-end">
    <span class="text-dark font-16 " >Totale: {{TotalePreventivo() | number: '2.2-2'}} €</span>
  </div>
<!--  <div class="d-flex justify-content-end" *ngIf="HasTotale && HasIva">-->
<!--    <span class="text-dark font-16">IVA: {{getIva(myProp.voci) | number: '2.2-2'}} €</span>-->
<!--  </div>-->
<!--  <div class="d-flex justify-content-end" *ngIf="HasTotale && HasIva">-->
<!--    <span class="text-dark font-16">Totale + IVA: {{getTotaleIvato(myProp.voci) | number: '2.2-2'}} €</span>-->
<!--  </div>-->
</div>
<div class="card" *ngIf="ProgettoSelezionato?.blocchi && permission.isPermitted('menu-blocchi') && environment.ProgettiAddon['CampiVociPreventivo']">
  <div class="card-body">
    <app-blocchi-list [(Blocchi)]="ProgettoSelezionato.blocchi"></app-blocchi-list>
  </div>
</div>
<div class="card" *ngIf="genericFiles?.length > 0 ">
  <div class="card-body">
    <h4 class="card-title" style="background-color: #87858525; min-height: 40px">
      {{'Allegati'|translate}}
      &nbsp;
      <span *ngIf="genericFiles?.length > 0"  class="badge badge-info badge-pill px-3 font-weight-bold font-14">{{genericFiles.length}}</span>
    </h4>
    <div  *ngIf="genericFiles?.length > 0 "  class="row">
      <table  class=" table bg-white table-hover align-middle mb-0 ">
        <thead>
        <tr>
          <th>Nome</th>
          <th scope="col">Descrizione</th>
          <th scope="col">Data</th>
          <th scope="col">Operatore</th>
          <th scope="col">Azioni</th>
        </tr>
        </thead>
        <tbody >
        <tr *ngFor="let item of genericFiles">
          <td (click)='download(item)'>
            <span class="text-dark font-medium font-16">{{item.file}}</span>
          </td>
          <td class="align-middle"  (click)='download(item)'>
            <span >
               {{ item.description }}
            </span>
          </td>
          <td class="align-middle" (click)='download(item)'>
            <span>
              {{item.date | date: 'dd/MM/yyyy'}}
            </span>
          </td>
          <td class="align-middle" (click)='download(item)'>
            <span>
              <label>{{ item.caricatoDa }}</label>
            </span>
          </td>

          <td class="align-middle">
            <a href="javascript:void(0)" *ngIf="includesExtensions(item, ['.pdf', '.jpg', '.jpeg', '.png'])" class="link font-16 text-info font-medium mr-2" (click)="view(item)">
              <i class="fas fa-eye"></i>
            </a>
            <a href="javascript:void(0)" class="link font-16 font-weight-bold" (click)='download(item)'>
              <i-feather name="download" class="feather-sm"></i-feather>
            </a>
            <a href="javascript:void(0)" *ngIf="fileDiProgetto(item) " class="link font-16 text-danger font-weight-bold" (click)='deletefile(item)'>
            <i-feather name="trash-2" class="feather-sm"></i-feather>
            </a>

          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <hr>
  </div>
</div>
<div class="card"*ngIf="!environment.ProgettiAddon['hideFile'] && permission.isPermitted('lista-file') ">
  <div class="card-body">
    <app-file-uploader [url]="'/progetti/progetti/file'" [(ListaFile)]="!genericFiles" [(id)]="ProgettoSelezionato.id" [(listafile)]="ProgettoSelezionato.files" (onChange)="onFileChanged()"></app-file-uploader>
  </div>
</div>


<br>
<br>
<br>
<br>

<aside  style="position: fixed;

    bottom: 20px;
    right: 0;"  >
  <div    >
    <div class="d-md-flex align-items-center justify-content-end">
      <button *ngIf="ProgettoSelezionato && ProgettoSelezionato.id && environment.Modules.Prima_Nota"  type="submit" (click)="OpenGantt()"
        class="ml-auto btn btn-rounded btn-dark p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Gantt
          <i class="mdi mdi-table-row-plus-after"></i></span>
      </button>
      <button *ngIf="ProgettoSelezionato && ProgettoSelezionato.id && environment.Modules.Prima_Nota"  type="submit" (click)="CreaFattura()"
              class="ml-auto btn btn-rounded btn-dark p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Genera Fattura
          <i class="fas fa-money-bill-alt"></i></span>
      </button>
      <button *ngIf="ProgettoSelezionato && environment.ProgettiAddon['sottoOfferte'] && (isPreventivo || !environment.ProgettiAddon['HideVoci'])"  type="submit" (click)="newSubOfferta()"
              class="ml-auto btn btn-rounded btn-dark p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> {{'Nuova Sottofferta' | translate}}
          <i class="fas fa-money-bill-alt"></i></span>
      </button>
      <button *ngIf="ProgettoSelezionato?.id && environment.ProgettiAddon['Revisioni']"  type="submit" (click)="NewRevisione()" class="ml-auto btn btn-rounded btn-dark p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Nuova Revisione
          <i class="fas fa-money-bill-alt"></i></span>
      </button>
      <button *ngIf="ProgettoSelezionato?.id && environment.ProgettiAddon['sync'] && permission.hasOperativeRoles(['AZ', 'SA'])" type="submit" (click)="SyncGamma()"
        class="ml-auto btn btn-rounded btn-dark p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Aggiorna da gamma
          <i class="fas fa-sync"></i></span>
      </button>
      
      <a href="mailto:{{ProgettoSelezionato.clienteObject.pec ?? ProgettoSelezionato.clienteObject.email ?? 'noEmailFound@verificaspa.it'}}?subject={{encodeURIComponent('accettazione proposta contrattuale per verifica impianti elettrici DPR 462/01 e assegnazione numero di pratica:') }}&body={{encodeURIComponent(getTextPec())}}" target="_top" (click)="SendPec()" class=" btn btn-rounded btn-info p-2 waves-effect waves-light" *ngIf="hasPecButton()">
      <span class="ml-1 text-white font-weight-bold"> Invia Pec </span>
      <i class="far fa-address-card "></i>
    </a>
<!--      <a [href]="'mailto:' + (ProgettoSelezionato.clienteObject.pec ?? ProgettoSelezionato.clienteObject.email ?? 'noEmailFound@verificaspa.it')-->
<!--    + '?subject=' + encodeURIComponent('Accettazione Vs. proposta contrattuale per la verifica degli impianti elettrici di cui al DPR 462/01 del 22/10/2001 e assegnazione numero di pratica per impianto sito in:')-->
<!--    + '&body=' + encodeURIComponent(getTextPec())"-->
<!--         target="_top"-->
<!--         (click)="SendPec()"-->
<!--         class="btn btn-rounded btn-info p-2 waves-effect waves-light"-->
<!--         *ngIf="hasPecButton()">-->
<!--        <span class="ml-1 text-white font-weight-bold"> Invia Pec </span>-->
<!--        <i class="far fa-address-card "></i>-->
<!--      </a>-->
      <app-InviaEmail *ngIf="Email?.length > 0" [(Lista)]="Email" [restRoute]="'/progetti/progetti/send'"></app-InviaEmail>
      <button type="submit" (click)="saveClick()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Salva </span>
        <i-feather name="save" class="feather-sm "></i-feather>
      </button>
      <button type="submit" (click)="saveClick(true)" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Salva e chiudi</span>
        <i-feather name="save" class="feather-sm "></i-feather>
      </button>
      <app-stampa [Stampe]="Stampe" *ngIf="Stampe && Stampe.length > 0"></app-stampa>
    </div>
  </div>
</aside>
